import ResetPasswordForm from '@bvi/dashboard/feature/auth/ui/reset-password-form';

export const ResetPasswordPage = () => {
  return <ResetPasswordForm />;
};
